import { render, staticRenderFns } from "./notice.vue?vue&type=template&id=12ec1ee1&scoped=true&"
import script from "./notice.vue?vue&type=script&lang=js&"
export * from "./notice.vue?vue&type=script&lang=js&"
import style0 from "./notice.vue?vue&type=style&index=0&id=12ec1ee1&lang=scss&scoped=true&"
import style1 from "./notice.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ec1ee1",
  null
  
)

export default component.exports